module.exports = __webpack_public_path__ + "static/media/sociology-not-enrolled.6d51f01c.svg";